import React from 'react'
import './index.sass'

const Logo = () => (
  <img src="/assets/logo.svg" alt="LOGO" className='navLogo' />
)

export default Logo
